import { useContext, useEffect, useState } from 'react'
import SspContext from 'selfServicePortal/contexts/SspContext'
import appConfig from 'app.config'
import { ProductType } from 'selfServicePortal/interfaces/i-api-support'

import bluecard_no from 'img/card-images/bluecard_no.png'
import goldcard_no from 'img/card-images/goldcard_no.png'
import goldcard_no_mc from 'img/card-images/goldcard_no_mc.png'

export const useCardImage = () => {
	const { isCard, isMarketing } = useContext(SspContext)
	const [img, setImg] = useState('')

	const checkDate = () => {
		const currentDate = new Date().toJSON().slice(0, 10)
		const from = new Date(isMarketing?.startDate!)
		const to = new Date(isMarketing?.endDate!)
		const check = new Date(currentDate)
		return check > from && check < to
	}

	useEffect(() => {
		if (isCard?.isCard === true) {
			switch (appConfig.country) {
				case 'no':
					setImg(getCardImageForNo(isCard.color))
					break
				case 'de':
				case 'at':
				case 'es':
				case 'it':
					setImg(getCardImageForEu(isMarketing))
					break
				default:
					setImg(goldcard_no_mc)
					break
			}
		}
		//eslint-disable-next-line
	})

	const getCardImageForNo = (color: any) => {
		switch (color) {
			case 'blue':
				return bluecard_no
			case 'gold-no':
				return goldcard_no
			case 'gold-mc-no':
				return goldcard_no_mc
			default:
				return ''
		}
	}

	const getCardImageForEu = (marketing: any) => {
		if (
			marketing?.product === ProductType.Card &&
			marketing?.imageRef !== undefined &&
			checkDate()
		) {
			return marketing.imageRef
		} else {
			return goldcard_no_mc
		}
	}

	return img
}
